import React from 'react';
import { Modal } from 'antd';
import cn from 'classnames';
import { Button, BUTTON_TYPES } from '_atoms/Button';
import { ReactComponent as Close } from 'dist/icons/close.svg';
import { ReactComponent as CircularProgress } from 'dist/icons/loading.svg';
import type { PopupProps } from './types';
import './style.scss';

export const Popup: React.FC<PopupProps> = ({
  className,
  children,
  destroyOnClose = true,
  loading,
  cancelButtonProps,
  okButtonProps,
  onClose,
  footerExtra,
  ...props
}) => (
  <Modal
    destroyOnClose={destroyOnClose}
    className={cn('popup-default', { loading }, className)}
    wrapClassName="popup-default__wrap"
    closeIcon={<Close onClick={cancelButtonProps?.onClick ?? okButtonProps?.onClick ?? onClose} />}
    footer={
      <div className="popup-default__footer">
        {footerExtra}
        {cancelButtonProps && <Button {...cancelButtonProps} />}
        {okButtonProps && <Button type={BUTTON_TYPES.PRIMARY} {...okButtonProps} />}
      </div>
    }
    {...props}
  >
    {children}
    <div className="popup-default__loading">
      <CircularProgress width={40} height={40} />
    </div>
  </Modal>
);
